import React from "react";

const MovieCard = ({ movie, onClick }) => {
    return (
        <div className="movie" onClick={onClick}>
            <div>
                <span>{movie.Type}</span>
                <h4>{movie.Year}</h4>
            </div>
            <div style={{ cursor: "pointer" }}>
                <img
                    alt={movie.Title}
                    src={movie.Poster !== "N/A" ? movie.Poster : "https://via.placeholder.com/400"}
                />
            </div>
            <div>
                <h3>{movie.Title}</h3>
            </div>
        </div>
    );
};

export default MovieCard;